let tempData: string | any[] = [];
const data = {
  filter: {
    title: "filter",
    pageName: "filter",
    genre: "filter",
    hideFilter: true,
    filters: [
    ],
  },
  header: {
    navigation: [
      {
        title: "savedeventfilters",
        url: "eventPageFilter",
      },
      {
        title: "savedhashfilters",
        url: "hashPageFilter",
      },
      // {
      //   title: "savedcomputerfilters",
      //   url: "computerPageFilter",
      // },
    ],
  },
  component: {
    type: "ag-table",
    options: {
      columns: [
        {
          label: "Title",
          field: "title",
          sortable: false,
        },
        {
          label: "filter",
          field: "filterJsonData",
          sortable: false,
          // display: function(row: any) {
          //   const data = JSON.parse(row.filterJsonData)
          //   let template = "";

          //   for (let i = 0; i < data.length; i++) {
          //     template += "<li><strong>" + data[i].name +"</strong><span>" + (data[i].selectedLabel) ? data[i].selectedLabel : data[i].value.selectedLabel + "</span></li>";
          //   }

          //   return `<ul class='saved-filter-element'>`+ template +`</ul>`;
          // }
        },
        {
          label: "",
          field: "run",
          components: [
            {
              component: "runSavedFilter",
            },
          ],
        },
        {
          label: "",
          field: "edit",
          components: [
            {
              component: "tableDeleteComponent",
            },
          ],
        },
      ],
      rows: [],
      total: 0,
      sortable: {
        order: "firstName",
        sort: "asc",
      },
      page: 1,
      pageSize: 5,
      isLoading: false,
      fetchTable: (options: any) => {
        tempData = options.allData;
        const page = options.page;
        const pageSize = options.pageSize;
        const data = tempData.slice((page - 1) * pageSize, page * pageSize);

        (options || {}).rows = data;
      },
    },
  },
};

export default data;
